import { render, staticRenderFns } from "./DefaultEnglish.vue?vue&type=template&id=19067516&"
import script from "./DefaultEnglish.vue?vue&type=script&lang=js&"
export * from "./DefaultEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports